import { jsx as _jsx } from "react/jsx-runtime";
import { MediaPlayer } from "@vidstack/react";
import { forwardRef } from "react";
import Icon from "../../../../icons";
import MiniProvider from "../MiniProvider";
const MiniPlayer = forwardRef(({ src, className, onClick, index, pinned, maximized, muted, showLogo, hasBackground }, ref) => {
    return src ? (_jsx(MediaPlayer, { ref: ref, src: src, keyDisabled: true, onClick: onClick, muted: muted, children: _jsx(MiniProvider, { index: index, pinned: pinned, maximized: maximized, className: className, showLogo: showLogo, hasBackground: hasBackground }) })) : (_jsx("div", { className: "flex size-full items-center justify-center", children: _jsx(Icon, { name: "cb-logo-cobli-name", color: "white", className: "!size-1/2" }) }));
});
MiniPlayer.displayName = "MiniPlayer";
export default MiniPlayer;
